module.exports = __webpack_public_path__ + "static/media/p1_s6.496c7bd2.ogg";